import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React from 'react';
import { commaFormat } from 'components/features/new-report/utils/formatter';

export type PortfolioChartPresenterProps<Id extends number | string> = {
  data: {
    id: Id;
    value: number;
  }[];
  idToTitle: (id: Id) => string;
  idToColor: (id: Id) => string;
  valueFormatter: (value: number) => string;

  chart: {
    title: string;
    width?: number;
    height?: number;
    fontSize?: string;
  };

  options?: Highcharts.Options;
};

export const PortfolioChartPresenter = <Id extends number | string>({
  data,
  idToTitle,
  valueFormatter,
  idToColor,
  chart,
  options: options_,
}: PortfolioChartPresenterProps<Id>): React.ReactElement => {
  const series: Highcharts.Options['series'] = [
    {
      type: 'pie',
      data: data.map(
        (datum): Highcharts.PointOptionsObject => {
          return {
            title: valueFormatter(datum.value),
            label: idToTitle(datum.id),
            name: idToTitle(datum.id),
            color: idToColor(datum.id),
            y: datum.value,
          };
        }
      ),
    },
  ];
  const options: Highcharts.Options = Highcharts.merge(
    {
      credits: { enabled: false },

      title: {
        text: chart.title,
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontWeight: 'bold',
          fontSize: chart.fontSize !== undefined ? chart.fontSize : '18px',
        },
        y: 20,
      },
      subtitle: {
        text: '',
      },
      exporting: {
        enabled: false,
      },

      plotOptions: {
        pie: {
          innerSize: '50%',
          dataLabels: {
            enabled: false,
            distance: '-30%',
          },
        },
      },

      tooltip: {
        outside: true,
        distance: 0,
        formatter(): string {
          return `${this.point.name}: ${commaFormat(
            this.point.percentage ?? 0,
            {
              numberOfDecimals: 1,
            }
          )}%`;
        },
      },

      chart: {
        width: chart.width !== undefined ? chart.width : 128,
        margin: 0,
        height: chart.height !== undefined ? chart.height : 128,
      },

      series,
    },
    options_
  );
  return (
    <>
      <HighchartsReact
        {...{
          highcharts: Highcharts,
          options,
        }}
      />
    </>
  );
};
